<template>
  <div>
    <v-card
      :class="$style.orders_widget"
      :loading="orders_loading"
    >
      <div :class="$style.widget_title">
        <span class="display-3">Заказы</span>
      </div>

      <template v-if="is_filters">
        <div class="d-flex mb-6">
          <v-row>
            <v-col
              cols="12"
              xl="4"
              lg="6"
              md="12"
              sm="6"
              xs="12"
            >
              <Select
                :value="filters.order_user_id"
                :items="users"
                :class="[$style.select, $style.filterField]"
                item-text="full_name"
                item_value="id"
                label="Сотрудник"
                dense
                hide-details
                clearable
                blue_icon
                multiple
                @input="filter_update('order_user_id', $event, 'orders')"
              />
            </v-col>
            <v-col
              cols="12"
              xl="4"
              lg="6"
              md="12"
              sm="6"
              xs="12"
            >
              <Select
                :value="filters.order_organization_id"
                :items="orgs"
                :class="[$style.select, $style.filterField]"
                label="Организация"
                item-text="name_organization"
                item_value="id"
                multiple
                dense
                hide-details
                clearable
                blue_icon
                @input="filter_update('order_organization_id', $event, 'orders')"
              />
            </v-col>
            <v-col
              cols="12"
              xl="4"
              lg="6"
              md="12"
              sm="6"
              xs="12"
            >
              <Select
                :value="filters.external_organizations"
                :items="external_orgs"
                :class="[$style.select, $style.filterField]"
                label="Организация АТОЛ"
                multiple
                dense
                hide-details
                clearable
                blue_icon
                @input="filter_update('external_organizations', $event, 'orders')"
              />
            </v-col>
          </v-row>
        </div>
      </template>

      <template v-if="is_filters">
        <div :class="$style.widget_box">
          <div class="d-flex align-center pl-4 pr-4">
            <span class="font-weight-medium">СТАТУС ЗАКАЗА</span>
          </div>
          <div
            v-for="item in analytics_statuses"
            :key="item.title"
            :class="$style.widget_item"
          >
            <span class="headline font-weight-regular">{{ item.title }}</span>
            <span class="headline font-weight-bold">{{ item.value }}</span>
          </div>
        </div>
        <div
          :class="$style.widget_box"
          class="mt-5"
        >
          <div class="d-flex align-center pl-4 pr-4">
            <span class="font-weight-medium">СТАТУС ОПЛАТЫ</span>
          </div>
          <div
            v-for="item in analytics_payment_statuses"
            :key="item.title"
            :class="$style.widget_item"
          >
            <span class="headline font-weight-regular">{{ item.title }}</span>
            <span class="headline font-weight-bold">{{ item.value }}</span>
          </div>
        </div>
      </template>
      <template v-else>
        <div :class="$style.widget_box">
          <div class="d-flex align-center pl-4 pr-4">
            <span class="font-weight-medium">СТАТУС ЗАКАЗА</span>
          </div>
          <div
            v-for="item in statuses"
            :key="item.title"
            :class="$style.widget_item"
          >
            <span class="headline font-weight-regular">{{ item.title }}</span>
            <span class="headline font-weight-bold">{{ item.value }}</span>
          </div>
        </div>
        <div
          :class="$style.widget_box"
          class="mt-5"
        >
          <div class="d-flex align-center pl-4 pr-4">
            <span class="font-weight-medium">СТАТУС ОПЛАТЫ</span>
          </div>
          <div
            v-for="item in payment_statuses"
            :key="item.title"
            :class="$style.widget_item"
          >
            <span class="headline font-weight-regular">{{ item.title }}</span>
            <span class="headline font-weight-bold">{{ item.value }}</span>
          </div>
        </div>
      </template>
    </v-card>
  </div>
</template>

<script lang="ts">
import {
  Vue, Component, Prop, Emit,
} from 'vue-property-decorator';
import { widgets_store, analytics_store } from '@/store';
import { Select } from '@/components/global';
import { AnalyticsFilters } from '@/modules/analytics/types';

const { state } = widgets_store;

const analytics_state = analytics_store.state;

@Component({
  components: {
    Select,
  },
})
export default class WidgetOrders extends Vue {
  @Prop({ type: Boolean, default: false })
  is_filters!: boolean;

  @Emit()
  filter_update(key: keyof AnalyticsFilters, value: unknown, section: string) {
    analytics_store.mutations.UPD_FILTER_KEY({ key, value, section });
  }

  get total_count_statuses() {
    return state.widgets.orders?.statuses.total_count;
  }

  get statuses() {
    return state.widgets.orders?.statuses.items;
  }

  get total_count_payment_statuses() {
    return state.widgets.orders?.payment_statuses.total_count;
  }

  get payment_statuses() {
    return state.widgets.orders?.payment_statuses.items;
  }

  get analytics_statuses() {
    const response_filters = this.has_response_filters();

    return response_filters
      ? analytics_state.response_filters.orders.statuses?.items
      : analytics_state.analytics.orders.statuses?.items;
  }

  get analytics_payment_statuses() {
    const response_filters = this.has_response_filters();

    return response_filters
      ? analytics_state.response_filters.orders.payment_statuses?.items
      : analytics_state.analytics.orders.payment_statuses?.items;
  }

  get users() {
    return analytics_state.users;
  }

  get orgs() {
    return analytics_state.organizations;
  }

  get external_orgs() {
    return analytics_state.external_organization;
  }

  get filters() {
    return analytics_state.filters;
  }

  get orders_loading() {
    return analytics_state.orders_loading;
  }

  has_response_filters() {
    return (
      analytics_state.filters.order_organization_id.length > 0
      || analytics_state.filters.order_user_id.length > 0
      || analytics_state.filters.external_organizations.length > 0
    );
  }
}
</script>

<style module lang="scss">
@import '@/scss/common/filter-blocks.scss';

.orders_widget {
  // height: 588px;
  display: flex;
  flex-direction: column;
  padding: 24px;
}
.widget_box {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.widget_title {
  margin-bottom: 24px;
  font-style: 24px;
  font-weight: 600;
  line-height: 32px;
  color: #13141C;
}
.widget_item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px;
}
.widget_item:nth-child(even) {
  background-color: #F6F7FA;
  border-radius: 8px;
}
.filterField {
  max-width: 100% !important;
}
.datepickerMargin {
  margin-bottom: -14px;
}
</style>
